mutation NotePaymentCreate($input: NotePaymentCreateInput!) {
  notePaymentCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
